import { Editor } from 'tinymce';

export function insertSpanAtTheCursor(ed: Editor, selectionRng: Range) {
	const wrapper = ed.dom.create('span');
	const insertRng = selectionRng.cloneRange();
	insertRng.collapse(true);
	insertRng.insertNode(wrapper);
	const rng = ed.dom.createRng();
	rng.setStart(wrapper, 0);
	rng.collapse(true);
	ed.selection.setRng(rng);
}
